import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DiscountPopup from "./components/DiscountPopup";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import ServicesPage from "./pages/Services";
import GalleryPage from "./pages/Gallery";
import About from "./pages/About";
import LocationDetail from "./pages/LocationDetail";
import BlogPage from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ServiceCategory from "./pages/ServiceCategory";
import ServiceSubCategory from "./pages/ServiceSubCategory";
import FranchisePage from "./pages/Franchise";
import LocationSEOPage from "./pages/LocationSEO";
import NailashesBasaveshwarnagar from "./pages/NailashesBasaveshwarnagar";

// Scroll to top on route change or handle hash navigation
const ScrollHandler = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

// Conditionally render Footer (hide on About page)
const ConditionalFooter = () => {
  const { pathname } = useLocation();
  // Hide footer on /about page as it has its own contact section
  if (pathname === '/about') return null;
  return <Footer />;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#F9F6F0]">
        <BrowserRouter>
          <ScrollHandler />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:categorySlug" element={<ServiceCategory />} />
            <Route path="/services/:categorySlug/:subCategorySlug" element={<ServiceSubCategory />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/location/:slug" element={<LocationDetail />} />
            {/* 301 Redirects for old URLs - redirect to new canonical URLs */}
            <Route path="/location/nailashes-basaveshwarnagar" element={<Navigate to="/nailashes-basaveshwarnagar" replace />} />
            <Route path="/location/basaveshwarnagar" element={<Navigate to="/nailashes-basaveshwarnagar" replace />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/franchise" element={<FranchisePage />} />
            {/* Dedicated Location Pages */}
            <Route path="/nailashes-basaveshwarnagar" element={<NailashesBasaveshwarnagar />} />
            {/* SEO Location Pages */}
            <Route path="/nails-rr-nagar" element={<LocationSEOPage />} />
            <Route path="/nails-basaveshwarnagar" element={<LocationSEOPage />} />
            <Route path="/nails-sahakarnagar" element={<LocationSEOPage />} />
            <Route path="/nails-varthur" element={<LocationSEOPage />} />
            <Route path="/nails-sarjapur-road" element={<LocationSEOPage />} />
            <Route path="/nails-gunjur" element={<LocationSEOPage />} />
            <Route path="/nail-salon-rr-nagar" element={<LocationSEOPage />} />
            <Route path="/nail-salon-basaveshwarnagar" element={<LocationSEOPage />} />
            <Route path="/nail-salon-varthur" element={<LocationSEOPage />} />
            <Route path="/manicure-pedicure-bangalore" element={<LocationSEOPage />} />
            {/* Service-Specific Location Pages */}
            <Route path="/nail-extensions-basaveshwarnagar" element={<NailashesBasaveshwarnagar />} />
            <Route path="/nail-art-basaveshwarnagar" element={<NailashesBasaveshwarnagar />} />
            <Route path="/manicure-pedicure-basaveshwarnagar" element={<NailashesBasaveshwarnagar />} />
            <Route path="/lash-extensions-basaveshwarnagar" element={<NailashesBasaveshwarnagar />} />
          </Routes>
          <ConditionalFooter />
          <DiscountPopup />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
